import axios from 'axios'

export const client = axios.create({
    baseURL: process.env.GATSBY_API_URL,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/json',
    },
})
